import { render } from "./EmployeeSalary.vue?vue&type=template&id=41252432&scoped=true"
import script from "./EmployeeSalary.vue?vue&type=script&lang=js"
export * from "./EmployeeSalary.vue?vue&type=script&lang=js"

import "./EmployeeSalary.vue?vue&type=style&index=0&id=41252432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41252432"]])

export default __exports__